import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faClock,
  faPhone,
  faTruckFast,
} from '@fortawesome/free-solid-svg-icons'
import InstagramIcon from '../../assets/icons/instagram.svg?react'
import { useTranslation } from 'react-i18next'
import { useAppNavigate, useAppType } from '../../context/AppContext'
import { INSTAGRAM_LINK } from '../../utils/constants'
import { BRANDS } from '../../utils/brand'
import { PandaSign } from '../panda-sign/PandaSign'
import { getGeneralInfo } from '../../utils/generalInfo'
import Credit from '../credit/Credit'
import './Footer.scss'

const c = 'footer'

const Footer = () => {
  const { t } = useTranslation()
  const navigate = useAppNavigate()
  const brand = BRANDS[useAppType()]
  const generalInfo = getGeneralInfo()

  return (
    <footer className={c}>
      <PandaSign size={84} className={`${c}__peek`} />
      <div className={`${c}__content`}>
        <div className={`${c}__brand`}>
          <img src={brand.mascot} alt='' />
          <div>
            {brand.first} <b>{brand.second}</b>
          </div>
        </div>

        <div className={`${c}__col`}>
          <div className={`${c}__title`}>{t('CONTACT_US')}</div>
          {[generalInfo.phone1, generalInfo.phone2]
            .filter(Boolean)
            .map((phone) => (
              <a key={phone} href={`tel:${phone}`} className={`${c}__link`}>
                <FontAwesomeIcon icon={faPhone} /> {phone}
              </a>
            ))}
          <div className={`${c}__link`}>
            <FontAwesomeIcon icon={faClock} /> {generalInfo.minTime} –{' '}
            {generalInfo.maxTime}
          </div>
        </div>

        <div className={`${c}__col`}>
          <div className={`${c}__title`}>{t('COMPANY')}</div>
          <button
            className={`${c}__link`}
            onClick={() => navigate('/delivery-conditions')}
          >
            <FontAwesomeIcon icon={faTruckFast} /> {t('DELIVERY_CONDITIONS')}
          </button>
        </div>

        <div className={`${c}__col`}>
          <div className={`${c}__title`}>{t('SOCIALS')}</div>
          <a
            href={INSTAGRAM_LINK}
            target='_blank'
            rel='noreferrer'
            className={`${c}__insta`}
            aria-label='Instagram'
          >
            <InstagramIcon />
          </a>
        </div>
      </div>
      <div className={`${c}__bottom`}>
        <Credit />
      </div>
    </footer>
  )
}

export default Footer
